import { LocaleItem } from './locale-item.model';

export class DataVariableOptions {
  id: string;
  optionOrderId: number;
  defaultOptionName: string;
  linkedOptions?: string[];
  exclusive?: boolean;
  optionTextLocales: LocaleItem[];
  percentage?: number;
}
